import { Space } from "antd";
import styled from "styled-components";

export const FixedWidthSpace = styled(Space)`
  width: 300px;
`;
